import React from 'react';
import {Icon} from 'antd';

import InstructionLayout, {
    InstructionImage,
    InstructionSpotlight,
    InstructionStep
} from '../instruction-layout';


const scheduleItems = [
    {
        id: 'loading',
        number: 1,
        content: (
            <>
                Перейдите в раздел
                <strong> «Погрузка-разгрузка»</strong>.
            </>
        ),
        area: {
            top: 12.55,
            left: 21.8,
            width: 12.49,
            height: 23.26
        }
    },
    {
        id: 'schedule',
        number: 2,
        content: (
            <>
                Откройте
                <strong> «Расписание погрузки и разгрузки»</strong>.
            </>
        ),
        area: {
            top: 65,
            left: 0.6,
            width: 19.2,
            height: 24
        }
    }
];


const attachPhotoItems = [
    {
        id: 'attach-photo',
        number: 1,
        content: (
            <>
                Нажмите кнопку
                <strong> «Прикрепить фото»</strong>.
            </>
        ),
        area: {
            top: 46.2,
            left: 80.59,
            width: 18.39,
            height: 15.04
        }
    }
];


const loadingItems = [
    {
        id: 'loading',
        number: 1,
        content: (
            <>
                Нажмите кнопку <strong>«Погрузка»</strong>.
            </>
        ),
        area: {
            top: 39.86,
            left: 80.71,
            width: 18.73,
            height: 11.89
        }
    }
];


const driverArrivalItems = [
    {
        id: 'driver-arrived',
        number: 3,
        content: (
            <>
                После прибытия на склад нажмите кнопку
                <strong> «Прибыл на погрузку»</strong>.
            </>
        ),
        area: {
            top: 71.28,
            left: 10.71,
            width: 84.72,
            height: 21.33
        }
    }
];


const timeWindowRules = [
    'Для каждого распределительного центра укажите количество ворот, используемых для отгрузки, и часы работы.',
    'Стандартная продолжительность погрузки одного транспортного средства составляет 60 минут.',
    'Время на сбор заказа по умолчанию составляет 60 минут. Значение можно изменить в настройках распределительного центра.',
    'Для замороженной, охлаждённой продукции и внутригородских рейсов можно настроить приоритетное время и допустимое количество погрузок.',
];


const driverActions = [
    'Установите Telegram-бот или MAX всем водителям, выполняющим рейсы через платформу.',
    'После оформления рейса водитель получает сообщение с информацией о погрузке.',
];


export default function TimeWindowsInstruction() {
    return (
        <InstructionLayout title="Временные окна">
            <p className="instruction-intro">
                Временные окна помогают распределять поток транспортных
                средств и планировать загрузку склада. После выбора времени
                перевозчиком запись появляется в личном кабинете склада.
            </p>

            <div className="service-highlight">
                <span className="service-highlight__icon">
                    <Icon type="clock-circle"/>
                </span>

                <div>
                    <strong className="service-highlight__title">
                        Запись на погрузку
                    </strong>

                    <p className="service-highlight__text">
                        Склад видит выбранные перевозчиками дату, время,
                        ворота и информацию о рейсе.
                    </p>
                </div>
            </div>

            <h2 className="instruction-section-title">
                Действия склада
            </h2>

            <InstructionStep
                number="1"
                title="Проверьте запись на погрузку"
            >
                <div className="instruction-copy">
                    <p>
                        Откройте расписание погрузки и разгрузки,
                        затем используйте фильтры, чтобы найти
                        необходимую запись.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/time-windows/01-loading-schedule.png"
                    alt="Переход к расписанию погрузки и разгрузки"
                    items={scheduleItems}
                />

                <div className="instruction-media-list">
                    <div className="instruction-media-item">
                        <p className="instruction-media-item__caption">
                            Выберите дату, распределительный центр
                            и тип рейса. Найденные записи появятся
                            в таблице.
                        </p>

                        <InstructionImage
                            src="/img/instructions/time-windows/02-loading-list.png"
                            alt="Список записей на погрузку и разгрузку"
                        />
                    </div>
                </div>
            </InstructionStep>

            <InstructionStep
                number="2"
                title="Проверьте транспортное средство"
            >
                <div className="instruction-copy">
                    <p>
                        Если для проверки транспортного средства
                        требуется фотография, загрузите необходимый
                        снимок.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/time-windows/03-attach-photo.png"
                    alt="Кнопка прикрепления фотографии"
                    items={attachPhotoItems}
                />

                <div className="service-note">
                    <Icon
                        className="service-note__icon"
                        type="info-circle"
                    />

                    <p className="service-note__text">
                        Если водитель уже проходил проверку
                        транспортного средства в течение последнего
                        месяца, повторная фотография не требуется.
                    </p>
                </div>
            </InstructionStep>

            <InstructionStep
                number="3"
                title="Зафиксируйте начало погрузки"
            >
                <div className="instruction-copy">
                    <p>
                        Начинайте погрузку только после того,
                        как транспортное средство установлено
                        на ворота и погрузка фактически началась.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/time-windows/04-loading-button.png"
                    alt="Кнопка начала погрузки"
                    items={loadingItems}
                />
            </InstructionStep>

            <section className="service-section">
                <h2 className="service-section__title">
                    Как формируются временные окна
                </h2>

                <p className="service-section__description">
                    Доступное перевозчику расписание зависит от настроек
                    распределительного центра.
                </p>

                <div className="service-checklist">
                    {timeWindowRules.map((rule, index) => (
                        <div
                            className="service-checklist__item"
                            key={rule}
                        >
                            <span className="service-checklist__number">
                                {index + 1}
                            </span>

                            <p className="service-checklist__text">
                                {rule}
                            </p>
                        </div>
                    ))}
                </div>
            </section>

            <div className="service-note">
                <Icon
                    className="service-note__icon"
                    type="info-circle"
                />

                <p className="service-note__text">
                    Например, распределительный центр работает с 09:00
                    до 18:00, а время на сбор заказа составляет 60 минут.
                    При оформлении рейса после 17:00 перевозчик не сможет
                    записаться на 18:00 этого дня и на 09:00 следующего дня.
                </p>
            </div>

            <section className="service-section service-section--spaced">
                <h2 className="service-section__title">
                    Приоритетные рейсы
                </h2>

                <p className="service-section__description">
                    Для распределительных центров, работающих с замороженной
                    или охлаждённой продукцией, можно выделить отдельное время
                    и количество погрузок. Аналогичная настройка доступна
                    для внутригородских рейсов.
                </p>

                <p className="service-section__description">
                    В выбранный период перевозчики, выполняющие дальние рейсы,
                    не смогут записаться на погрузку. Внутригородские рейсы
                    смогут записываться утром и после завершения приоритетного
                    периода.
                </p>
            </section>

            <section className="service-section">
                <h2 className="service-section__title">
                    Действия водителя
                </h2>

                <div className="service-checklist">
                    {driverActions.map((action, index) => (
                        <div
                            className="service-checklist__item"
                            key={action}
                        >
                            <span className="service-checklist__number">
                                {index + 1}
                            </span>

                            <p className="service-checklist__text">
                                {action}
                            </p>
                        </div>
                    ))}
                </div>

                <InstructionSpotlight
                    src="/img/instructions/time-windows/05-driver-arrived.png"
                    alt="Кнопка «Прибыл на погрузку» в сообщении водителю"
                    items={driverArrivalItems}
                />
            </section>
        </InstructionLayout>
    );
}